import BRLogo from "../../assets/BR_Logo.svg";
import BBLogo from "../../assets/BB_Logo.svg";
import BWLogo from "../../assets/BW_Logo.svg";

export function getCardConfig(cardText) {
  let config = {
    bgClass: "bg-brandBR",
    prefixCard: "Certificate *",
    textColor: "text-white",
    logoSrc: BRLogo,
  };

  if (!cardText) return config;

  if (cardText.startsWith("31060900") || cardText.includes("31060900")) {
    config = {
      bgClass: "bg-brandBB",
      prefixCard: "Card *",
      textColor: "text-black",
      logoSrc: BBLogo,
    };
  } else if (cardText.startsWith("963203") || cardText.includes("963203")) {
    config = {
      bgClass: "bg-brandBB",
      prefixCard: "Certificate *",
      textColor: "text-black",
      logoSrc: BBLogo,
    };
  } else if (cardText.startsWith("60894100") || cardText.includes("60894100")) {
    config = {
      bgClass: "bg-brandBR",
      prefixCard: "Card *",
      textColor: "text-white",
      logoSrc: BRLogo,
    };
  } else if (cardText.startsWith("963201") || cardText.includes("963201")) {
    config = {
      bgClass: "bg-brandBR",
      prefixCard: "Certificate *",
      textColor: "text-white",
      logoSrc: BRLogo,
    };
  } else if (cardText.startsWith("22078900") || cardText.includes("22078900")) {
    config = {
      bgClass: "bg-brandBW",
      prefixCard: "Card *",
      textColor: "text-white",
      logoSrc: BWLogo,
    };
  } else if (cardText.startsWith("963202") || cardText.includes("963202")) {
    config = {
      bgClass: "bg-brandBW",
      prefixCard: "Certificate *",
      textColor: "text-white",
      logoSrc: BWLogo,
    };
  }

  return config;
}
